import React, { useState, useEffect } from "react";
import "./Schedule.css";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import useFormContext from "./useFormContext.js";
import useFormContextFamily from "../GetEventMarsComplete.jsx/useFormMarsComplete.js";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import axios from 'axios';
import { DOWNLOAD_ATTACHMENTS_URL, DOWNLOAD_BRIEF_URL } from "../ApiDetails.js";
import { FaTrash } from "react-icons/fa";

//add fonts here
const fontArr = [
  "Mars Centra",
  "times-new-roman",
  "sans-serif",
  "serif",
  "monospace",
];
let fonts = Quill.import("attributors/style/font");
fonts.whitelist = fontArr;
Quill.register(fonts, true);

const modules = {
  toolbar: [
    [{ font: fontArr }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
};

const defaultStyles = `
  .ql-editor {
    font-family: 'Mars Centra';
  }
`;

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
  "image",
];

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" style={infoIconStyle}>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
    <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="8" r="1" fill="currentColor" />
  </svg>
);

const infoIconStyle = {
  color: 'darkblue',
  marginRight: '10px',
  fontSize: '16px',
  cursor: 'pointer'
};

const ScheduleRequestor = ({familyMode}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const {
    eventFormData,
    handleScheduleAgendaChange,
    handleScheduleItenaryChange,
    handleBriefUpload,
    handleBriefDelete,
    handleUploadBriefFileClick,
    hiddenUploadBriefFileInput,
    hiddenAttachmentFileInput,
    handleUploadAttachmentClick,
    handleAttachmentsUpload,
    handleAttachmentDelete,
    nonEditable,
    handleNonEditableUI,
    attachments,
    briefs
  } = familyMode==="false" ? useFormContext() : useFormContextFamily() ;

  useEffect(() => {
    if (nonEditable) {
      handleNonEditableUI();
    }
  }, []);

  const handleInfoClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false); // Closes the modal
  };

  const fileDownload = require('js-file-download');
  const downloadAttachment = (attachment) => {
    axios.get(`${DOWNLOAD_ATTACHMENTS_URL}/${encodeURIComponent(attachment)}`, { responseType: 'blob' })
      .then(response => {
        fileDownload(response.data, attachment);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  const downloadBrief = (brief) => {
    axios.get(`${DOWNLOAD_BRIEF_URL}/${encodeURIComponent(brief)}`, { responseType: 'blob' })
      .then(response => {
        fileDownload(response.data, brief);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  useEffect(() => {
    const status = eventFormData.eventStatus;
    if (status === "Completed") {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [eventFormData.eventStatus]);

  const content = (
    <>
      <style>{defaultStyles}</style>
      <div className="col-md-10">
        <div className=" bg-light rounded my-4 p-4 mt-3 visit-summary">
          <div className="visit-title">Visit Summary</div>
          <div className="guidance">
            <strong>Guidances :</strong> Please share here what you expect to be
            on the agenda for this visit
          </div>
          <ReactQuill
            theme="snow"
            value={eventFormData.schedule.visitSummary}
            name="visitSummary"
            onChange={handleScheduleAgendaChange}
            readOnly={isReadOnly}
            modules={modules}
            formats={formats}
            placeholder={nonEditable ? "" : "Please share here what you expect to be on the agenda for this visit"}
          />
        </div>

        <div className=" bg-light my-4 p-4 rounded p-3 ">
          <div className="itinerary-title">draft itinerary</div>
          <div className="guidance">
            <strong>Guidances :</strong> Please share here what you expect to be
            the itinerary for this visit
          </div>
          <ReactQuill
            theme="snow"
            name="draftItinerary"
            value={eventFormData.schedule.draftItinerary}
            onChange={handleScheduleItenaryChange}
            readOnly={isReadOnly}
            modules={modules}
            formats={formats}
            placeholder={nonEditable ? "" : "Please share here what you expect to be the itinerary for this visit"}
          />
        </div>
        <div className="bg-light rounded p-4 mt-3">
          <label htmlFor="staticEmail" className="custom-font col-form-label">
            BRIEF - Optional at the request stage, required once event is accepted
            <div onClick={handleInfoClick} style={{ cursor: "pointer", position: "relative", display: "inline-block", marginLeft: "10px" }}>
              <InfoIcon />

            </div>
          </label>
          <Modal open={isModalOpen} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                height: "80%",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 2,
                overflow: "hidden",
              }}
            >
              <iframe
                src="/files/Site_Briefing_Template_for_engagement.pdf"
                style={{
                  width: "100%",
                  height: "90%",
                  border: "none",
                }}
                title="Document Viewer"
              ></iframe>
              <button
                onClick={handleClose}
                style={{
                  marginTop: "10px",
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >Close</button>
            </Box>
          </Modal>
          <div className="m-2">
            <button
              type="button"
              id="uploadBrief"
              className="btn-custom-schedule btn btn-outline-danger"
              onClick={handleUploadBriefFileClick}
            >
              UPLOAD A BRIEF FILE
            </button>
            <input
              type="file"
              name="attachmentsbrief"
              onChange={handleBriefUpload}
              ref={hiddenUploadBriefFileInput}
              style={{ display: "none" }}
            />
          </div>
          <ul className="list-group" id="SchbriffList">
            {briefs.map((brief, index) => (
              <li key={index} id={brief} className="list-group-item-custom list-group-item m-1 d-flex justify-content-between align-items-center">
                <u>
                  <a href="#" onClick={(e) => { e.preventDefault(); downloadBrief(brief); }}>{brief}</a>
                </u>
                <button
                  className={"btn-delete"}
                  onClick={(e) => { e.preventDefault(); handleBriefDelete(e, eventFormData.eventId, brief); }}>
                  <FaTrash />
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-light rounded p-4 mt-3 mb-5">
          <label htmlFor="staticEmail" className="custom-font col-form-label">
            ATTACHMENTS - <small style={{ fontSize: "12px" }}>Optional</small>
          </label>
          <div className="m-2">
            <button
              type="button"
              id="uploadAttachment"
              className="btn-custom-schedule btn btn-outline-danger"
              onClick={handleUploadAttachmentClick}
            >
              UPLOAD NEW ATTACHMENT
            </button>
            <input
              type="file"
              name="attachments"
              onChange={handleAttachmentsUpload}
              ref={hiddenAttachmentFileInput}
              style={{ display: "none" }}
            />
          </div>
          <ul className="list-group" id="SchAttListAdmin">
            {attachments.map((attachment, index) => (
              <li key={index} id={attachment} className="list-group-item-custom list-group-item m-1 d-flex justify-content-between align-items-center">
                <u>
                  <a href="#" onClick={(e) => {e.preventDefault();downloadAttachment(attachment);}}>{attachment}</a>
                </u>
                <button
                  className={"btn-delete"}
                  onClick={(e) => { e.preventDefault(); handleAttachmentDelete(e, eventFormData.eventId, attachment); }}>
                  <FaTrash />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </>
  );
  return content;
};

export default ScheduleRequestor;